<rask-header [uppercase]="true">
  Feature Toggling
</rask-header>
@if (form) {
  <div>
    <rask-tabs parameterName="tab" class="mb-0 h-100 pb-3" aid="features" layout="child">
      @if (getGroupByName('BLL'); as group) {
        <rask-tab [label]="group.get('type').value" [routeId]="group.get('type').value">
          @if ($any(group.controls.list).controls; as items) {
            <ng-container *ngTemplateOutlet="table; context: {group: items}"></ng-container>
          }
        </rask-tab>
      }
      @if (getGroupByName('GUI'); as group) {
        <rask-tab [label]="group.get('type').value" [routeId]="group.get('type').value">
          @if ($any(group.controls.list).controls; as items) {
            <ng-container *ngTemplateOutlet="table; context: {group: items}"></ng-container>
          }
        </rask-tab>
      }
      @if (getGroupByName('GENERAL'); as group) {
        <rask-tab [label]="group.get('type').value" [routeId]="group.get('type').value">
          @if ($any(group.controls.list).controls; as items) {
            <ng-container *ngTemplateOutlet="table; context: {group: items}"></ng-container>
          }
        </rask-tab>
      }
    </rask-tabs>
    <rask-button class="mt-2" aid="buttonSpara" raskHotkey="ctrl+s" color="primary" [disabled]="!canSave()" (click)="saveChanges()">Spara</rask-button>
  </div>
}

<ng-template #table let-group="group">
  <table class="svea-table featureToggleTable ms-2">
    <thead>
      <tr class="rask-header-row rask-row">
        <th class="name-column-header">Namn</th>
        <th class="active-column-header">Aktiv</th>
      </tr>
    </thead>
    <tbody>
      <ng-container>
        @for (item of group; track item) {
          <tr>
            <ng-container [formGroup]="item">
              <td class="svea-input fkm-input-col">{{item.get('name').value}}</td>
              <td class="svea-input fkm-input-col"><rask-checkbox formControlName="active"></rask-checkbox></td>
            </ng-container>
          </tr>
        }
      </ng-container>
    </tbody>
  </table>
</ng-template>